import React from "react";
import Typist from 'react-typist';
import 'react-typist/dist/Typist.css'
import messages from '../components/messages';
import Link from "gatsby-link";

const someFunc = (arg) => arg;

const Index = props => {
  return (
      <div className="c-content-box">
          <h2>Rob's Structural Apps:</h2>
            <Typist>
                <h2><strong>Helping engineers calculating better</strong></h2>
                     <Typist.Delay ms={400} />
                {messages.tagline.services.map((service, index) => (
                  <div style={{display: 'inline'}} key={index}>
                      <h1 style={{ display: 'inline' }}><strong>...and faster</strong></h1>
                  </div>
                ))}
            </Typist><br /><br />
      <h2
        className={`
          js-action-button-anchor
          c-content-box__subheadline
          c-content-box__subheadline--with-button
        `}
    >
        Find out more
      </h2>
    </div>
  );
};

export default Index;



// WEBPACK FOOTER //
// ./src/pages/index.jsx